import { Moment } from 'moment';
import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { momentTransformer } from 'typeormgen';
import EpisodicBase from '../episodic-base.entity';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import PrBudgetProp from '../pr-budget-props/pr-budget-prop.entity';

@Entity('episodic_budget_props')
export default class EpisodicBudgetProp extends EpisodicBase {
	static tableName = 'episodic_budget_props';

	@Column('int')
	episodic_id: number;

	@Column('int')
	episodic_prop_id: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@OneToMany(
		(type) => PrBudgetProp,
		(prBudgetProp) => prBudgetProp.episodicBudgetProp
	)
	prBudgetProps: PrBudgetProp[];

	@ManyToOne((type) => EpisodicProp, (epProp) => epProp.episodicBudgetProps)
	@JoinColumn({
		name: 'episodic_prop_id',
	})
	episodicProp: EpisodicProp;
}
